var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhoneReactivateCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#13D246;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#CCCCCC;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Phone / play call") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "B_Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1999.000000, -3607.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Structure",
    transform: "translate(133.000000, 107.000000)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "phone_reactivate_call",
    transform: "translate(2.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0",
    d: "M29.5,25.7l6.7,5.5c0.5,0.4,0.5,1.1,0,1.5c-0.3,0.3-0.6,0.5-0.9,0.7c-1.8,1.4-3.9,2.6-6.2,3.3 c-1.4,0.5-2.9,0.4-4.2-0.2C14.4,32.1,5.9,23.6,1.4,13c-0.6-1.3-0.7-2.8-0.2-4.2C2,6.5,3.1,4.4,4.6,2.6C4.8,2.3,5,2,5.3,1.7 c0.4-0.5,1.1-0.4,1.5,0l5.5,6.7c0.3,0.4,0.3,1-0.1,1.3L10,12c-0.7,0.7-0.8,1.7-0.3,2.5C13.3,20,18,24.7,23.6,28.3 c0.8,0.5,1.8,0.4,2.5-0.3l2.2-2.2C28.6,25.4,29.1,25.4,29.5,25.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "40,8 24,0 24,16  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneReactivateCall);
export default __webpack_public_path__ + "static/media/icon-phone_reactivate_call.3d338901d3b3d8aeace54f4d39e53fd5.svg";
export { ForwardRef as ReactComponent };